<template>
    <div id="body-wrap" class="">
        <LayoutHeader />
        <Lfcnvnc />
        <Footer />
        <FooterPc />
        <Common />
        <PulseLoader :loading="loading" />
    </div>
</template>

<script>
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import Footer from "@/views/layout/Footer";
import FooterPc from "@/views/layout/FooterPc";
import Lfcnvnc from '@/views/lfcnvnc/Lfcnvnc.vue';
import Common from '@/views/common/Common.vue';
import PulseLoader from '@/views/common/PulseLoader.vue';

import { mapGetters } from 'vuex';
import { defualtMeta } from '@/confs/vue.meta';

export default {
    metaInfo: {
        meta: defualtMeta,
    },
    data(){
        return {
            loading: false,
        }
    },
    components: {
        LayoutHeader,
        Footer,
        FooterPc,
        Lfcnvnc,
        Common,
        PulseLoader,
    },
    computed: {
        ...mapGetters({
        }),
    },
    created() {
        this.loading = true;
        this.$eventBus.$on('Change::Loader::State', (state) => {
            this.loading = state;
        });
        this.$eventBus.$once('NaverMap::map-loaded', (map)=>{
            this.$store.dispatch('SET_NAVER_MAPS', map);
        });
        
        Promise.all([
            this.$store.dispatch('FETCH_HP_CATE_LIST'), 
            this.$store.dispatch('FETCH_HOS_FAC_LIST'),
            this.$store.dispatch('FETCH_PHAR_FAC_LIST'),
            // this.$store.dispatch('FETCH_APT_LIST'),
            this.$store.dispatch('FETCH_APT_LIST_ADDONG'),
            this.$store.dispatch('FETCH_WORK_INCRUDE_INFO', 100),
        ]).then(()=>{
            this.loading = false;
            this.$eventBus.$emit('LfcnvncApp::loaded-data');
        });
    },
    methods: {
    },
};
</script>
